import { render } from "./TaskDetail.vue?vue&type=template&id=65bb502e&scoped=true"
import script from "./TaskDetail.vue?vue&type=script&lang=js"
export * from "./TaskDetail.vue?vue&type=script&lang=js"

import "./TaskDetail.vue?vue&type=style&index=0&id=65bb502e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65bb502e"

export default script